import 'bootstrap/dist/css/bootstrap.css';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import App from './application/App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import SessionApi from './api-services/SessionApi';
import { datadogRum } from '@datadog/browser-rum';

(async () => {
    let applicationInfo = null;
    try {
        applicationInfo = await SessionApi.getApplicationInfo();
    } catch (e) {
        //ignore
    }
    datadogRum.init({
        applicationId: 'ea66e6c7-ed54-4bff-bb86-1cb048aa52c0',
        clientToken: 'pub9ff347c0201a3d320b266a6bcb9165a1',
        site: 'datadoghq.com',
        service: 'pcp2.0',
        env: applicationInfo?.configurationShortName.toLowerCase() ?? 'unknow',
        version: applicationInfo?.version ?? '0.0.0.0',
        sampleRate: 100,
        premiumSampleRate: 100,
        trackInteractions: true,
        defaultPrivacyLevel: 'mask-user-input'
    });
    datadogRum.startSessionReplayRecording();
})();
    
const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');

ReactDOM.render(
  <BrowserRouter basename={baseUrl}>
    <App />
  </BrowserRouter>,
  rootElement);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
